var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", { attrs: { title: _vm.$t("message.customer") } }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.storecompanyperson")))
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control form-control-sm custom-select",
                  attrs: { disabled: true }
                },
                [
                  _vm.inv.customer
                    ? _c("option", [
                        _vm._v(_vm._s(_vm.inv.customer.customer_name))
                      ])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "form-group row mb-1" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.address")))]),
                  _vm._v(" "),
                  _c(
                    "textarea",
                    {
                      staticClass: "form-control",
                      staticStyle: { height: "150px" },
                      attrs: { disabled: true }
                    },
                    [_vm._v(_vm._s(_vm.inv.customer.address))]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "form-group row mb-1" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.tel")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { disabled: true, type: "text" },
                    domProps: {
                      value: _vm.getPartnerContact(_vm.inv.customer.contacts)
                        .tel
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row mb-1" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { disabled: true, type: "text" },
                    domProps: {
                      value: _vm.getPartnerContact(_vm.inv.customer.contacts)
                        .email
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row mb-0" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.taxpayerno")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { disabled: true, type: "text" },
                    domProps: { value: _vm.inv.customer.tax_id }
                  })
                ])
              ])
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("message.reference") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("documents.so")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control form-control-sm custom-select",
                  attrs: { disabled: true }
                },
                [_c("option", [_vm._v(_vm._s(_vm.inv.in_code))])]
              )
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-header", { attrs: { title: _vm.$t("message.date") } }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.date")))]),
                    _vm._v(" "),
                    _c("BaseInputDatePicker", {
                      model: {
                        value: _vm.form.created_at,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "created_at", $$v)
                        },
                        expression: "form.created_at"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-header", {
            attrs: { title: _vm.$t("message.infopayment") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("message.paidat")))]),
                    _vm._v(" "),
                    _c("BaseInputDatePicker", {
                      attrs: { mode: "dateTime", is24hr: "" },
                      model: {
                        value: _vm.form.paid_at,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "paid_at", $$v)
                        },
                        expression: "form.paid_at"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.paymentmethod")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.payment_method,
                          expression: "form.payment_method"
                        }
                      ],
                      staticClass: "form-control form-control-sm custom-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "payment_method",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(_vm._s(_vm.$t("placeholder.select")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "cash" } }, [
                        _vm._v(_vm._s(_vm.$t("payment_methods.cash")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "card" } }, [
                        _vm._v(_vm._s(_vm.$t("payment_methods.card")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "promptpay" } }, [
                        _vm._v(_vm._s(_vm.$t("payment_methods.promptpay")))
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.paidamount", { string: _vm.currency })
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.paid_amount,
                        expression: "form.paid_amount"
                      }
                    ],
                    staticClass: "form-control number-only text-select-all",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.paid_amount },
                    on: {
                      keypress: _vm.numberOnly,
                      keyup: function($event) {
                        _vm.form.paid_amount = _vm.setToValidNumber(
                          _vm.form.paid_amount
                        )
                      },
                      blur: function($event) {
                        _vm.form.paid_amount = _vm.setToCustomDigitsNumber(
                          _vm.form.paid_amount
                        )
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "paid_amount", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "no-margin" }, [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("message.orderlist") }
          }),
          _vm._v(" "),
          _c("order", {
            attrs: {
              data: _vm.form.orders,
              disabled: false,
              validation: _vm.trickValidation,
              type: "rt"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "no-margin" }, [
      _c("div", { staticClass: "col-md-12 no-padding" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.note,
                      expression: "form.note"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "min-height": "126px" },
                  attrs: { placeholder: _vm.$t("placeholder.note") },
                  domProps: { value: _vm.form.note },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "note", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "col-md-12 row no-padding no-margin" },
              [
                _c("div", { staticClass: "col-12 row no-margin no-padding" }, [
                  _c("div", { staticClass: "col-6 no-padding mb-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.total")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 no-padding mb-2 text-right" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getNumber(_vm.getTotal(_vm.form.orders).sub)
                          ) +
                          "\n              "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.getTotal(_vm.form.orders).discount > 0
                  ? _c(
                      "div",
                      { staticClass: "col-12 row no-margin no-padding" },
                      [
                        _c("div", { staticClass: "col-6 no-padding mb-2" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.discount")) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 no-padding mb-2 text-right" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getNumber(
                                    _vm.getTotal(_vm.form.orders).discount
                                  )
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.getTotal(_vm.form.orders).discount > 0
                  ? _c(
                      "div",
                      { staticClass: "col-12 row no-margin no-padding" },
                      [
                        _c("div", { staticClass: "col-6 no-padding mb-2" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.discounted_total")) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 no-padding mb-2 text-right" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getNumber(
                                    _vm.getTotal(_vm.form.orders).sub -
                                      _vm.getTotal(_vm.form.orders).discount
                                  )
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.taxResults, function(tax, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "col-12 row no-margin no-padding"
                    },
                    [
                      _c("div", { staticClass: "col-6 no-padding mb-2" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(tax.displayText) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-6 no-padding mb-2 text-right" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getNumber(tax.total)) +
                              "\n              "
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 row no-margin no-padding" }, [
                  _c("div", { staticClass: "col-6 no-padding" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.grandtotal")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 no-padding text-right" }, [
                    _c(
                      "span",
                      {
                        class: [{ "text-underline-border": !_vm.isActiveWht }]
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.getNumber(_vm.getTotal(_vm.form.orders).grand)
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                ])
              ],
              2
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c52bbb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c52bbb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/FormReceipt.vue
// module id = null
// module chunks = 